export const no = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Tilbake",
        save: "Lagre",
        saved: "Lagt til",
        cancel: "Avbryt",
        close: "Lukk",
        accessDenied: "Tilgang nektet",
        noExportPermission: "Du har ikke tillatelse til å eksportere denne bilens data.",
        delete: "Slett",
        downgrade: "Nedgradering",
        downgradeConfirm: "Er du sikker på at du vil nedgradere til gratisplan?",
        edit: "Rediger",
        loading: "Laster...",
        confirm: "Bekreft",
        processing: "Behandler...",
        history: "Historikk",
        currentCar: "Nåværende bil",
        purchasedCarTitle: "Bilkjøp",
        initialCost: "Startkostnad",
        done: "Ferdig",
        ok: "OK",
        error: "Feil",
        errorSaving: "Feil ved lagring av data",
        mandatoryFieldsError: "Vennligst fyll ut alle obligatoriske felt korrekt.",
        search: "Søk",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Ugyldig e-postformat",
        today: "I dag",
        car: "Bil",
        all: "Alle",
        deleteConfirm: "Slett",
        unsavedChangesTitle: "Ikke lagrede endringer",
        unsavedChangesMessage: "Vil du lagre endringer før du forlater?",
        dontSave: "Ikke lagre",
        additionalOptions: "Tilleggsalternativer",
        add: "Legg til",
        fileTooLarge: "Fil er for stor. Maksimal størrelse er {limit} MB.",
        storageFull: "Lagringsgrensen er overskredet. Maksimal lagring er {limit} MB.",
        dailyUploadLimit: "Daglig opplastingsgrense nådd ({limit} filer/dag). Prøv igjen i morgen.",
        hourlyUploadLimit: "Timeopplastingsgrense nådd ({limit} filer/time). Prøv igjen om en time.",
        fileCountLimit: "Maksimalt {limit} filer tillatt per element.",
        emailParseLimitReached: "Grensen for e-postbehandling er nådd. Vennligst oppgrader planen din eller behandle manuelt.",
        emailLimitText: "Grensen for e-postbehandling er nådd.",
        monthlyEmailScans: "Månedlige e-postskanninger",
        lifetimeEmailScans: "Livstids e-postskanninger",
        monthlyFileScans: "Månedlige kvitteringsskanninger",
        lifetimeFileScans: "Livstids kvitteringsskanninger",
        fileLimitText: "Grensen for kvitteringsskanninger er nådd.",
        planFreeTier: "Gratis nivå",
        planProTier: "Pro nivå",
        uploadFailed: "Opplasting mislyktes",
        attachments: "Vedlegg",
        limitsAndUsage: "Grenser og bruk",
        addresses: "adresser",
        emailCopied: "E-postadresse kopiert!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Inkludert",
        proOnly: "PRO kun",
        month: "mnd",
        openInNewTab: "Åpne i ny fane",
        menu: "Meny",
        home: "Hjem",
        monthsShort: {
            0: "Jan",
            1: "Feb",
            2: "Mar",
            3: "Apr",
            4: "Mai",
            5: "Jun",
            6: "Jul",
            7: "Aug",
            8: "Sep",
            9: "Okt",
            10: "Nov",
            11: "Des",
        },
    },
    carMetadata: {
        bodyType: "Karosseritype",
        drivetrain: "Drivlinje",
        transmission: "Girkasse",
        bodyTypes: {
            sedan: "Sedan",
            hatchback: "Hatchback",
            wagon: "Stasjonsvogn",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupe",
            convertible: "Kabriolet",
            pickup: "Pickup",
            van: "Varebil / Minivan",
            commercial: "Kommersiell",
            other: "Annet",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Annen",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manuell",
            automatic: "Automatisk",
            cvt: "CVT",
            other: "Annen",
        },
        otherLabel: "Annet (spesifiser)",
        mileageLabel: "Kjørelengde",
    },
    auth: {
        welcome: "Velkommen",
        welcomeBack: "Velkommen tilbake",
        signIn: "Logg inn",
        signInWithGoogle: "Logg inn med Google",
        signOut: "Logg ut",
        magicLinkDesc: "Få en magisk lenke i e-posten din",
        magicLinkSent: "Magisk lenke sendt!",
        magicLinkCheckEmail: "Sjekk e-posten din og klikk på lenken for å logge inn.",
        emailAddress: "E-postadresse",
        getMagicLink: "Få magisk lenke",
        sending: "Sender...",
        linkSent: "Lenke sendt",
        orContinueWith: "Eller fortsett med",
        googleAccount: "Google-konto",
        newUserNote: "Ny her? Kontoen din vil bli opprettet automatisk ved første vellykkede innlogging.",
        magicLinkError: "Kunne ikke sende magisk lenke. Vennligst sjekk e-posten din og prøv igjen.",
        genericError: "En feil oppstod. Vennligst prøv igjen.",
        projectDescription: "Hold oversikt over bilkostnader, vedlikehold og historikk på ett sted.",
        loginError: "Kunne ikke logge inn",
        loggingIn: "Logger inn...",
        authenticating: "Autentiserer...",
        authenticatingDesc: "Vennligst vent mens vi sikrer sesjonen din.",
    },
    settings: {
        title: "Innstillinger",
        systemPreferences: "Systeminnstillinger",
        appSettings: "App-innstillinger",
        dangerZone: "Farlig sone",
        theme: "Tema",
        language: "Grensesnittsspråk",
        currency: "Valuta",
        units: "Enheter",
        distanceUnit: "Avstandsenhet",
        volumeUnit: "Volumenehet",
        expenseTypes: "Utgiftstyper",
        expenseTypesDesc: "Administrer kategorier",
        categories: "Kategorier",
        exportData: "Eksporter data",
        exportDesc: "Last ned omfattende CSV",
        importData: "Importer data",
        importDesc: "Gjenopprett fra CSV-sikkerhetskopi",
        deleteAccount: "Slett konto",
        deleteAccountDesc: "Fjern alle data permanent",
        enableSync: "Aktiver synkronisering",
        enableSyncDesc: "Synkroniser data på tvers av enheter",
        account: "Konto",
        accountPlan: "Konto plan",
        carsUsage: "Biler",
        carsLimitReached: "Bilgrensen er nådd",
        storageSize: "Lagringsstørrelse",
        emailScans: "E-postskanninger",
        fileScans: "Kvitteringsskanninger",
        plans: "Planer",
        currentlyPlan: "For øyeblikket",
        upgradePlan: "Oppgrader",
        manageSubscription: "Administrer abonnement",
        nextPayment: "Neste betaling",
        endsOn: "Slutter den",
        adminConsole: "Admin-konsoll",
        systemControl: "Systemkontroll",
        customCategories: "Egendefinerte kategorier og etiketter",
        interfaceTheme: "Grensesnitt-tema",
        light: "Lys",
        dark: "Mørk",
        timezone: "Tidssone",
        timezoneDesc: "Brukes for planlagte e-postpåminnelser",
        timeFormat: "Tidsformat",
        timeFormat24h: "24-timers (14:30)",
        timeFormat12h: "12-timers (2:30 PM)",
        kilometers: "kilometer (km)",
        miles: "miles (mi)",
        liters: "liter (l)",
        gallons: "galloner (gal)",
        accountManagement: "Kontoadministrasjon",
        contactUs: "Kontakt oss",
        contactDesc: "For forslag, funksjonsforespørsel og spørsmål",
        logOut: "Logg ut",
        logOutConfirmTitle: "Logg ut",
        logOutConfirmMessage: "Er du sikker på at du vil logge ut av kontoen din?",
        keepAccount: "Behold konto",
        deleteAccountConfirmTitle: "Slett konto",
        deleteAccountConfirmMessage: "Er du sikker på at du vil slette kontoen din permanent og all tilknyttede bildata? Denne handlingen kan ikke angres.",
        deletePermanently: "Slett permanent",
        deleting: "Sletter...",
        contactSupport: "Kontakt support",
        messageSent: "Melding sendt!",
        feedbackThanks: "Takk for tilbakemeldingen. Vi setter pris på innspillet ditt og vil se nærmere på det.",
        backToSettings: "Tilbake til innstillinger",
        subjectLabel: "Emne",
        messageLabel: "Melding",
        subjectPlaceholder: "Hva handler dette om?",
        messagePlaceholder: "Fortell oss om forslaget ditt, funksjonsforespørselen eller spørsmålet ditt...",
        enterSubjectAlert: "Vennligst skriv inn et emne",
        enterMessageAlert: "Vennligst skriv inn en melding",
        sendFailedAlert: "Kunne ikke sende melding. Vennligst prøv igjen senere.",
    },
    export: {
        title: "Eksporter data",
        generatePDF: "Generer PDF",
        carInformation: "Bilinformasjon",
        editInfo: "Rediger informasjonen nedenfor for å tilpasse eksporten din",
        editInfoHint: "Du kan fjerne eller endre eventuelle felt du ikke ønsker å inkludere",
        filters: "Filtre",
        expenseTypes: "Utgiftstyper",
        includeNotes: "Inkluder notater",
        includeImages: "Inkluder filer",
        hideDisabled: "Skjul deaktiverte elementer",
        itemsCount: "{total} elementer, {selected} valgt",
        selectAll: "Velg alle",
        deselectAll: "Fjern valg av alle",
        expenses: "Utgifter",
        notes: "Notater",
        spareParts: "Reservedeler",
        images: "Bilder",
        files: "Filer",
        summary: "Sammendrag",
        totalExpenses: "Totale utgifter",
        totalItems: "Totale elementer",
        generatedOn: "Generert den",
        noItemsSelected: "Ingen elementer valgt for eksport",
        noItemsAvailable: "Ingen elementer tilgjengelig for eksport",
        generating: "Genererer PDF...",
        downloadPDF: "Last ned PDF",
        pdfFileName: "{carName}_eksport_{date}.pdf",
        reportTitle: "Bilutgiftsrapport",
        exportButton: "Eksporter",
        generateCSV: "Generer CSV",
        formatSelectorTitle: "Velg format",
        formatSelectorMsg: "Vennligst velg eksportformat",
        proFeatureExportTitle: "Pro-funksjon: Eksporter data",
        proFeatureExportDesc: "Oppgrader til PRO for å eksportere bilhistorikken din til PDF.",
        exportRestrictedPopup: "Dataeksport er kun tilgjengelig for Pro-brukere.",
        allTypes: "Alle typer",
        statistics: "Statistikk",
        driven: "Kjørt",
        since: "Siden",
        averageCost: "Gjennomsnittlig kostnad",
        perKm: "per km",
        perMile: "per mil",
        period: "Periode",
        dateFrom: "Fra",
        dateTo: "Til",
        allTime: "Fjern filter",
        periodHint: "Hvis ingen periode er valgt — vises alle utgifter",
        noExpenses: "Ingen utgifter samsvarer med filtrene",
        expensesSection: "Utgifter",
        attachmentsSection: "Vedlegg",
        imagesCount: "{count} bilder",
        pdfsCount: "{count} PDF-er",
        includeParts: "Inkluder reservedeler",
        pageLabel: "Side",
    },
    expenses: {
        title: "Utgifter",
        newExpense: "Ny utgift",
        editExpense: "Rediger utgift",
        openExpense: "Åpne utgiftsoppføring",
        details: "Utgiftsdetaljer",
        selectType: "Velg type",
        selectTypePlaceholder: "Velg utgiftstype...",
        shortDescriptionPlaceholder: "Kort beskrivelse...",
        expenseTitle: "Tittel",
        logEntryTitleLabel: "Registrer tittel (valgfritt)",
        defaultTitlePlaceholder: "Standard tittel - {type}",
        autoTitlePlaceholder: "Vil bli automatisk fylt ut basert på valgte typer",
        carDataTitle: "Bildata",
        defaultTitlePrefix: "Standard tittel vil være -",
        addAnother: "Legg til en annen type utgift",
        addAnotherHint: "Hvis denne posten inkluderer flere typer utgifter, kan du legge dem alle til her for å sikre nøyaktige statistikker.",
        carValueDescription: "Estimert markedsverdi av bilen på dette tidspunktet.",
        type: "Type",
        date: "Dato",
        amount: "Beløp",
        totalAmount: "Totalt",
        splitCosts: "Dele kostnader?",
        combineCosts: "Kombiner kostnader",
        amountWork: "Arbeid",
        amountParts: "Deler",
        mileage: "Kilometerstand",
        carValue: "Bilverdi",
        description: "Beskrivelse",
        detailedDescription: "Detaljert beskrivelse",
        electricity: "Elektrisitet",
        fuelType: "Drivstofftype",
        fuelTypeOptions: {
            petrol: "Bensin",
            diesel: "Diesel",
            lpg: "LPG",
            electricity: "Elektrisitet",
        },
        carData: "Bildata",
        images: "Filer",
        addImages: "Legg til filer",
        addImagesPDFs: "Legg til bilder eller PDF-er",
        deleteExpense: "Slett utgift",
        deleteConfirm: "Er du sikker på at du vil slette denne utgiften?",
        saveSuccess: "Utgift lagret",
        thisExpense: "Denne utgiften",
        stats: {
            annual: "Årlig",
            allTime: "Alle tider",
            avgMonth: "Gjennomsnitt/måned",
            costPer: "Kostnad/",
            noExpenses: "Ingen utgifter ennå",
            dragToReorder: "Dra håndtaket for å endre rekkefølge",
        },
        expensesFound: "Opprettet",
        noExpensesFound: "Ingen utgifter funnet.",
        noDescription: "Ingen beskrivelse",
        imagesCount: "Bilder ({count})",
        deleteImageTitle: "Slett bilde",
        deleteImageConfirm: "Er du sikker på at du vil slette dette bildet? Denne handlingen kan ikke angres.",
        typeLabels: {
            fuel: "Drivstoff",
            car_wash: "Vask",
            repairs: "Reparasjoner",
            maintenance: "Vedlikehold",
            parts: "Reservedeler",
            insurance: "Forsikring",
            inspection: "Inspeksjon",
            tyres: "Dekk",
            parking: "Parkering",
            electricity: "Elektrisitet",
            taxes: "Skatter",
            other: "Annet",
            info: "Informasjon",
            service_maintenance: "Vedlikehold",
            service_repair: "Reparasjon",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Tjeneste",
            selectSubtype: "Velg tjenestetype",
            maintenance: "Vedlikehold",
            repair: "Reparasjon",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Gjentakende utgift",
        repeatToggle: "Gjenta denne utgiften",
        repeatFrequency: "Frekvens",
        monthly: "Månedlig",
        startDate: "Startdato",
        nextDate: "Neste oppføring vil bli generert",
        endDate: "Sluttdato",
        noEndDate: "Ingen sluttdato",
        copyOptions: "Kopier alternativer",
        copyTitle: "Kopier posttittel",
        copyLocation: "Kopier sted",
        copyDescription: "Kopier beskrivelse",
        active: "Aktiv",
        status: "Status",
        managedByRepeat: "Denne utgiften er en del av en gjentakende sekvens.",
        placeholder: "Her kan du sette opp automatisk gjentakelse for denne utgiften hvis den skjer regelmessig med samme beløp.",
        deleteRepeat: "Slett gjentakelse",
        deleteRepeatConfirm: "Er du sikker på at du vil stoppe og slette denne gjentakende sekvensen? Fremtidige oppføringer vil ikke bli generert. Tidligere oppføringer vil forbli.",
        relatedEntries: "Oppføringer i denne sekvensen",
        stopRepeat: "Stopp gjentakelse",
        isRepeating: "Gjentakende",
        noTerm: "Ubegrenset",
        until: "Siste oppføring vil bli generert",
        summaryCopy: "Systemet vil kopiere",
        simulate: "Simuler neste oppføringsgenerering",
        simulateSuccess: "Neste oppføringsgenerering simulert med suksess",
        simulateNoDate: "Ingen flere datoer å generere (sluttdato nådd)",
    },
    onboarding: {
        title: "Sett opp profil",
        welcome: "Velkommen!",
        subtitle: "Tilpass din kjøreopplevelse.",
        currency: "Valuta",
        preferredCurrency: "Foretrukket valuta",
        distUnit: "Avstandsenhet",
        volUnit: "Volum enhet",
        complete: "Fullfør oppsett",
    },
    cars: {
        unitChangeWarningTitle: "Advarsel om enhetsendring",
        unitChangeWarningMessage: "Å endre disse enhetene vil ikke konvertere dine eksisterende data. Alle historiske poster vil forbli akkurat som de er skrevet inn.",
        unitChangeWarningConfirm: "Forstått",
        title: "Garasje",
        carAdmins: "Biladministratorer",
        sharedWithMe: "Delt med meg",
        manageAdmins: "Administrer administratorer",
        adminEmail: "Administrator e-post",
        addAdmin: "Legg til administrator",
        addAdminPlaceholder: "f.eks. venn@email.com",
        removeAdmin: "Fjern",
        removeAdminConfirm: "Er du sikker på at du vil fjerne denne administratoren?",
        adminAdded: "Administrator lagt til",
        adminRemoved: "Administrator fjernet",
        removeMyAccess: "Fjern min tilgang",
        removeMyAccessConfirm: "Er du sikker på at du vil gi opp tilgang til denne bilen?",
        myAccessRemoved: "Tilgang fjernet",
        noAdminsYet: "Ingen administratorer lagt til ennå.",
        adminInfoText: "Administratorer kan legge til og redigere utgifter, notater og reservedeler, men kan ikke slette bilen selv.",
        newCar: "Legg til bil",
        carNotFound: "Bil ikke funnet",
        carNotFoundDesc: "Den forespurte bilen eksisterer ikke eller du har ikke tilgang.",
        accessDenied: "Tilgang nektet",
        accessDeniedDesc: "Denne bilen er privat og ikke offentlig tilgjengelig.",
        backToHome: "Tilbake til Hjem",
        adminRestricted: "Tilgang begrenset",
        adminRestrictedDesc: "Kun autoriserte administratorer kan få tilgang til denne konsollen. Vennligst gå tilbake til hovedapplikasjonen.",
        returnHome: "Gå tilbake til Hjem",
        editCar: "Rediger bil",
        name: "Bilnavn",
        model: "Modell",
        year: "År",
        plate: "Registreringsnummer",
        vin: "VIN-nummer",
        mileage: "Nåværende kilometerstand",
        initialMileage: "Første kilometerstand",
        engineType: "Motortype",
        tapToChangeIcon: "Trykk for å endre ikon",
        chooseIcon: "Velg ikon",
        imageTab: "Bilde",
        iconTab: "Ikon",
        chooseColor: "Velg farge",
        chooseEmoji: "Velg emoji",
        uploadImage: "Last opp bilde",
        clickToBrowse: "Klikk for å bla gjennom filer",
        currentCarIcon: "Nåværende bilikon",
        changeImage: "Endre bilde",
        zoom: "Zoom",
        rotate: "Rotere",
        removeChangeImage: "Fjern / Endre bilde",
        selectIcon: "Velg ikon",
        cropAndSave: "Beskjær & Lagre",
        displayName: "Visningsnavn",
        displayNamePlaceholder: "f.eks. Min helgebil",
        makeLabel: "Merke *",
        modelLabel: "Modell *",
        yearLabel: "År *",
        fuelTypeLabel: "Type *",
        licensePlateLabel: "Registreringsskilt",
        vinLabel: "VIN",
        notesLabel: "Notater (valgfritt)",
        notesPlaceholder: "f.eks. 1.6 TDI, 85kW, 1588cc, batteri 62kWh, AWD, osv.",
        publicAccess: "Gjør bilen offentlig tilgjengelig",
        publicAccessDesc: "Andre kan se denne bilen via delt lenke",
        shareLocations: "Tillat å se også tilleggslokasjoner",
        shareLocationsDesc: "Aktiver dette for å gjøre bilens lokasjoner synlige i offentlig visning",
        deleteCar: "Slett bil",
        deleteCarTitle: "Slett bil",
        deleteCarConfirm: "Er du sikker på at du vil slette '{name}'? Denne handlingen kan ikke angres.",
        noCars: "Ingen biler i garasjen din",
        addFirstCarNote: "Start reisen din ved å legge til ditt første kjøretøy for å spore utgifter.",
        addVehicle: "Legg til et kjøretøy",
        myVehicles: "Mine kjøretøy",
        favorites: "Favoritter",
        deleteConfirm: "Er du sikker på at du vil slette denne bilen? Alle tilknyttede utgifter vil bli slettet.",
        deleteFailed: "Kunne ikke slette bil",
        saveFailed: "Kunne ikke lagre bildata",
        adminActions: "Adminhandlinger",
        importCsv: "Importer CSV",
        clearData: "Tøm data",
        distanceUnitLabel: "Avstandsenhet",
        volumeUnitLabel: "Volum-enhet",
        currencyLabel: "Valuta",
        boughtAt: "Kjøpsdato",
        purchasePrice: "Kjøpesum",
        purchaseMileage: "Kjøpskilometerstand",
        createPurchaseRecord: "Opprett kjøpshistorikk automatisk",
        makePlaceholder: "f.eks. BMW",
        modelPlaceholder: "f.eks. X5",
        platePlaceholder: "f.eks. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Denne informasjonen vil opprette en initial 'Informasjon'-post i historikken din med de spesifiserte dataene.",
        availableTypes: "Tilgjengelige typer",
        dragToReorder: "Dra for å omorganisere",
        requestTypeNote: "Hvis du trenger en annen type - ",
        requestTypeAction: "gi oss beskjed!",
        emailProcessingTitle: "E-postbehandling",
        emailInstructions: "Videreformidle kvitteringene dine til adressen nedenfor. Vi vil hente data og opprette utgifter automatisk.",
        recentEmails: "Mottatte e-poster",
        viewAllEmails: "SE ALLE ({count})",
        noEmailsReceived: "Ingen e-poster mottatt ennå.",
        analysisResult: "Analyse resultat",
        vehicleInfo: "Kjøretøyinformasjon",
        preferences: "Innstillinger",
        purchaseHistory: "Kjøpshistorikk",
        emailProcessing: "E-postbehandling",
        publicAccessTitle: "Offentlig tilgang",
        expenseTypesTitle: "Utgiftstyper",
        adminActionsTitle: "Adminhandlinger",
        enterPurchaseDateAlert: "Vennligst oppgi kjøpsdato",
        allowedSenderEmails: "Tillatte avsender-e-poster",
        allowedEmailsDesc: "Legg til e-postadresser som har lov til å sende kvitteringer til denne bilen. Maksimalt 5 adresser.",
        noAllowedEmails: "Ingen tillatte e-poster lagt til.",
        emailAlreadyAdded: "Denne e-posten er allerede tillatt for denne bilen.",
        maxAllowedEmailsReached: "Maksimalt antall tillatte e-poster nådd.",
        addAllowedEmailPlaceholder: "Legg til tillatt e-post...",
        ownerEmail: "Eier",
        onlyOwner: "kun eier",
        defaultAllowed: "Alltid tillatt",
        carLimitReachedTitle: "Bilgrense nådd",
        carLimitReachedMessage: "Din {plan} plan tillater {limit} bil(er). Du har allerede {current}. Gå til innstillinger for å se grensene dine eller kontakt oss for å oppgradere.",
        carLimitGoToSettings: "Gå til Innstillinger",
        archivedCars: "Arkivert",
        archiveCar: "Arkiver bil",
        unarchiveCar: "Fjern fra arkiv",
        sellDate: "Salgsdato",
        sellPrice: "Salgspris",
        sellMileage: "Salgs kilometerstand",
        archiveConfirm: "Er du sikker på at du vil arkivere denne bilen?",
        archiveInstructions: "Å arkivere en bil betyr at den ikke lenger er din eller at du ikke lenger vedlikeholder den. Vennligst oppgi salgsdetaljene for statistikk. Dette vil gjøre bilen skrivebeskyttet. Feltene nedenfor kan fortsatt redigeres etterpå.",
        archivedBadge: "Arkivert",
        saleDetails: "Salgsdetaljer",
        saleDetailsNote: "Salgsdetaljer brukes til statistikk. Du kan oppdatere dem om nødvendig.",
        archiveDetailsNotFillable: "Vennligst fyll ut alle felt for å arkivere bilen",
        emailAddressWillBeAvailableAfterSave: "E-postadresse vil være tilgjengelig etter at bilen er lagret.",
        proFeatureAdminTitle: "Pro-funksjon: Biladministratorer",
        proFeatureAdminDesc: "Legg til andre brukere som kan se og administrere denne bilens data.",
        proFeatureEmailTitle: "Pro-funksjon: Ekstra avsendere",
        proFeatureEmailDesc: "Legg til andre tillatte e-postadresser som kvitteringer kan sendes fra til denne bilen.",
        estimatedMileage: "Estimert kilometerstand",
        summaryFrequencyLabel: "Oppsummeringsfrekvens",
        summaryFrequencyOptions: {
            none: "Av",
            monthly: "Månedlig",
            semiAnnually: "Halvårlig",
            annually: "Årlig",
        },
        healthProfilePrompt: "Fullfør helprofilen din for nøyaktig analyse!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Bensin",
        diesel: "Diesel",
        hybrid: "Hybrid",
        electric: "Elektrisk",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Kilometertrend",
        title: "Statistikk",
        allYears: "Alle år",
        totalSpent: "Totalt brukt",
        spentIn: "Brukt i {year}",
        perMonth: "per måned",
        overall: "totalt",
        vsPrev12m: "vs forrige 12m",
        rolling12m: "Siste 12m",
        byType: "Etter type",
        byMonth: "Etter måned",
        byYear: "Etter år",
        noData: "Ingen data for dette året",
        mostExpensive: "Dyrest",
        top: "Topp",
        untitled: "Uten tittel",
        assetAnalysis: "Analyse av eiendomsverdi og kostnader",
        burnNote: "* 'Total Burn' inkluderer både penger brukt og estimert verdiforringelse av bilen.",
        carMarketValue: "Bilens markedsverdi",
        cumulativeCosts: "Kumulative kostnader",
        totalBurn: "Total Burn (Kostnader + Verdiforringelse)",
        entries: "oppføringer",
        avgPrice: "Gjennomsnittlig pris",
        consumption: "Forbruk",
        price: "Pris",
        fuelPriceTrend: "Trender i drivstoffpriser",
        spendingTrend: "Utgiftstrend",
        costPerKmTrend: "Kostnad per 1 km",
        costPerMileTrend: "Kostnad per 1 mile",
        serviceTrendsTitle: "Service Trender",
        expensesOnMap: "Utgifter på kart",
        visitsCountLabel: "besøk",
        locationsSummary: "Oppsummering av steder",
        locationsCountLabel: "steder",
        noLocationsFoundTitle: "Ingen steder ennå",
        noLocationsFoundDesc: "Legg til steder i registrene dine for å se dem på kartet.",
        addMileageData: "Legg til kjørelengde",
        missingMileageInfo: "Ikke nok data til å beregne kostnad per avstand. Legg til minst 2 kjørelengdemålinger i denne perioden (eller en før denne perioden).",
        mileageModal: {
            title: "Legg til manglende kjørelengde",
            description: "For å nøyaktig beregne kostnader per avstand for {year}, må vi vite kjørelengden ved starten og slutten av året.",
            startOfYear: "Start av året (1. jan)",
            endOfYear: "Slutt av året (31. des)",
            currentMileage: "Nåværende kjørelengde",
            placeholder: "Skriv inn kjørelengde...",
            save: "Lagre data",
            foundNearby: "Funnet i nærheten ({date}): {value} {unit}",
            useExisting: "Bruk dette",
        },
        proAnalysis: "Pro-analyse",
        detailedAnalysis: "Detaljert analyse",
        upgradeToSee: "Oppgrader for å se →",
    },
    tabs: {
        dashboard: "Dashbord",
        expenses: "Utgifter",
        stats: "Statistikk",
        locations: "Steder",
        gallery: "Filer",
        parts: "Deler",
        notes: "Notater",
        repair: "Reparasjonsmodus",
        'repair-switch': "Bilbytte",
    },
    repairAnalysis: {
        title: "Analyse av reparasjonsbeslutninger",
        ownershipLength: "Eierskapslengde",
        currentValue: "Nåverdi",
        valueOutdated: "Verdien kan være utdatert",
        addValueToEnable: "Legg til nåverdi av bilen for å aktivere analysen",
        totalInvested: "Totalt investert",
        totalInvestedSub: "Kjøpesum + reparasjoner",
        totalExcludesFuel: "ekskluderer drivstoff / strøm",
        fuelLabelFuelOnly: "Drivstoff totalt",
        fuelLabelEnergyOnly: "Energi totalt",
        fuelLabelHybrid: "Drivstoff & Energi totalt",
        fuelTypeFuel: "drivstoff",
        fuelTypeEnergy: "strøm",
        fuelTypeHybrid: "drivstoff & strøm",
        fuelTotalLabel: "Drivstoff/Energi totalt:",
        projectionMode: "Prognosemodus",
        projectionModes: {
            lastYear: "Basert på fjoråret",
            average: "Historisk gjennomsnitt",
            trend: "Trend (lineær)",
        },
        brakeAssumption: "Vedlikehold inkluderer estimert 3-års bremsesyklus",
        repairBuffer: "Inkluderer aldersbasert reparasjonsrisikopuffer",
        yearLabel: "år",
        totalInvestedDesc: "Kjøpesum + alle reparasjoner",
        repairToValue: "Reparasjon til verdi (12m)",
        repairToValueExplain: "Reparasjoner €{cost} vs bilverdi €{value}. Under 20% er sunt; over 50% er høy risiko.",
        ownershipPressure: "Eierskapspress",
        ownershipPressureExplain: "Totalt kostnadspress: reparasjoner €{cost} + verdiforringelse vs €{value}. Over 35% signaliserer økonomisk stress.",
        investmentGap: "Investeringsgap",
        investmentGapExplain: "Totalt investert €{invested} minus nåverdi €{value}. Dette viser hvor mye du har 'tapt' på eierskap så langt.",
        investmentGapDesc: "Totalt investert - nåverdi",
        repairExpenses12m: "12m reparasjonskostnad",
        calculatedYearlyMileage: "Beregnet årlig kjøring: {km} km",
        calculatedYearlyRepairs: "Beregnet årlige reparasjoner: {amount}",
        set: "Sett",
        plannedRepairCost: "Planlagt reparasjonskostnad",
        whatIfTitle: "Hva om du bruker {amount} nå?",
        updatedScore: "Oppdatert poengsum",
        updatedVerdict: "Oppdatert vurdering",
        howIsItCalculated: "Hvordan beregnes dette?",
        usedLifespan: "Brukt: {usage}% av forventet levetid",
        remainingLifespan: "Gjenstående: ~{km} km",
        estimatedLifespan: "Estimert levetid: {km} km",
        lifecycle_stage_early: "Tidlig livssyklus – lav risiko for store feil",
        lifecycle_stage_mid: "Moden livssyklus – normal slitasje",
        lifecycle_stage_late: "Sen livssyklus – økt risiko for reparasjoner",
        lifecycle_stage_end: "Slutt på forventet levetid – høy risiko for store reparasjoner",
        calculationExplanation: "Analysen bruker kjøpesummen for kjøretøyet, nylige reparasjonskostnader og estimert nåverdi for å beregne en økonomisk helsepoengsum. Høye reparasjonskostnader i forhold til bilens verdi eller rask verdiforringelse vil senke poengsummen.",
        confidenceLabel: "Tillitt",
        confidenceLevel: {
            high: "Høy",
            medium: "Moderat",
            low: "Lav",
        },
        mentalFactorsTitle: "Forbedre nøyaktigheten med din erfaring",
        mentalFactorsCTA: "Rask sjekk (30 sek)",
        mentalFactorsSurveyTitle: "Din erfaring",
        mentalFactorsSurveyDesc: "Svar på 3 raske spørsmål for å tilpasse poengsummen din.",
        q1: "Møter bilen dine behov?",
        q1Help: "Plass, komfort, funksjoner",
        q2: "Liker du å kjøre bilen din?",
        q2Help: "Visuell, komfort, følelse",
        q3: "Bekymrer du deg for uventede sammenbrudd?",
        q3Help: "Pålitelige bekymringer",
        q4: "Er denne bilen for familie og lange turer?",
        q4Help: "Sikkerhet og pålitelighet prioritet",
        factorsTitle: "Vurderingsfaktorer",
        factorsDesc: "Se hva som påvirker poengsummen din",
        newCarComparison: "Sammenligning av ny bil",
        newCarComparisonDesc: "Sammenlign dine nåværende månedlige kostnader med å kjøpe en ny bil.",
        modeLeasing: "Leasing",
        modeFullPrice: "Full pris",
        downPayment: "Forskudd",
        leaseYears: "Leieperiode (år)",
        monthlyPayment: "Månedlig betaling",
        carPrice: "Bilens fullpris",
        ownershipYears: "Planlagt eierskap (år)",
        insuranceMonthly: "Månedlig CASCO / forsikring",
        currentMonthlyCost: "Nåværende bilkostnad",
        newCarMonthlyCost: "Kostnad for ny bil",
        newCarCheaper: "Ny bil er billigere med: {amount} / mnd",
        newCarMoreExpensive: "Ny bil er dyrere med: {amount} / mnd",
        newCarSameCost: "Kostnadene er helt like.",
        advancedSettings: "Avanserte innstillinger",
        yearlyMaint: "Årlig vedlikehold (€)",
        tyres3Yrs: "Dekk / 3 år (€)",
        depreciation5Yrs: "Avskrivning (5 år %)",
        newCarYear: "År for ny bil",
        cumulativeCosts: "Kumulative kostnader (projeksjon)",
        comparisonByYear: "Sammenligning per år",
        currentCarLabel: "Nåværende bil",
        newCarLabel: "Ny bil",
        resaleValue: "Gjenkjøpsverdi",
        startupCosts: "Oppstartskostnader (Brukt bil)",
        inspection: "Forhåndsinspeksjon",
        initialMaintenance: "Første vedlikehold + oljer",
        registration: "Registrering / Avgifter",
        total: "Totalt",
        currentCarTitle: "Nåværende bil",
        newCarTitle: "Potensiell bil",
        upfrontInvestment: "Første investering",
        monthlyReality: "Reell månedlig kostnad",
        depreciationShort: "Avskrivning",
        howCalculated: "Hvordan beregnes dette?",
        deltaMonthly: "Månedlig forskjell",
        deltaUpfront: "Første forskjell",
        surveyMeanings: {
            practical: {
                1: "Ikke i det hele tatt",
                2: "Dårlig tilpasning",
                3: "Gjennomsnittlig",
                4: "God tilpasning",
                5: "Perfekt tilpasning",
            },
            joy: {
                1: "Frustrerende",
                2: "Kjedelig",
                3: "Gjennomsnittlig",
                4: "Behagelig",
                5: "Veldig mye",
            },
            worry: {
                1: "Ikke bekymret",
                2: "Litt bekymret",
                3: "Bekymret",
                4: "Veldig bekymret",
                5: "Sikker på at jeg vil bryte sammen når som helst",
            },
        },
        verdicts: {
            KEEP: "Økonomisk fornuftig å beholde",
            borderline: "Grenseverdi – overvåk nøye",
            sell: "Høy økonomisk risiko – salg kan være rasjonelt",
        },
        factors: {
            trendInc: "Økende trend",
            trendIncDesc: "Reparasjonskostnadene vokser sammenlignet med i fjor.",
            lowDepreciation: "Fordel med lav avskrivning",
            lowDepreciationDesc: "Eldre/billige biler mister mindre verdi over tid.",
            stableRepairs: "Stabile reparasjoner",
            stableRepairsDesc: "Dine reparasjonskostnader er stabile eller synkende.",
            noHistoricalData: "Ingen data eldre enn 6 måneder.",
            lifecycle_stage: "Fase i bilens livssyklus",
            high_risk_phase: "Høy-risiko fase",
            high_risk_phase_desc: "Kombinasjonen av en sen livssyklusfase og økende reparasjonskostnader indikerer høy risiko.",
            lowCostKm: "Effektiv kostnad per km",
            lowCostKmDesc: "Den totale effektiviteten av å kjøre denne bilen er utmerket.",
            lowFixedCosts: "Lave faste kostnader",
            lowFixedCostsDesc: "Dine faste kostnader (skatter, forsikring) er lave.",
            usage: "Årlig bruk",
            usageDesc: "Kjørt distanse de siste 12 månedene.",
            accidentMinor: "Mindre ulykke",
            accidentMinorDesc: "Kosmetisk skade eller små reparasjoner.",
            structuralDamage: "Strukturell skade",
            structuralDamageDesc: "Ramme- eller strukturelle problemer reduserer verdien drastisk.",
            aiLifespanNearEnd: "Slutt på forventet levetid",
            aiLifespanAging: "Aldrende komponenter",
            aiLifespanGood: "Fordel med lav kilometerstand",
            aiLifespanDesc: "Basert på AI-estimert typisk levetid for denne modellen.",
            aiUpcomingRepairs: "Kommende reparasjoner (AI forutsigelse)",
            aiUpcomingRepairsDesc: "AI forutsier store komponentfeil snart basert på kilometerstand.",
            ownershipFatigue: "Eierskapsutmattelse",
            ownershipFatigueLong: "Langsiktig eierskap fører ofte til mental beredskap for et annet kjøretøy.",
            ownershipFatigueShort: "Innledende eierskapsbias skaper en sterkere tendens til å beholde bilen.",
            family_priority: "Familie & Lange Turer",
            replacement_comparison: "Erstatningssamling",
            none: "Ingen",
            surface: "Overflate",
            minor: "Liten",
            moderate: "Moderat",
            severe: "Alvorlig",
            structural: "Strukturell",
            major: "Større",
            critical: "Kritisk",
            full: "Full",
            improveLabel: "Hva ville forbedre dette:",
            info_original_price: "Den omtrentlige prisen på denne bilen da den var ny. Hjelper med å estimere verdistabilitet. Eldre biler med lavere gjenværende verdi er sikrere økonomisk.",
            info_current_value: "Hvor mye du kunne selge den for i dag. Brukes for å sjekke om reparasjoner er en stor prosentandel av bilens verdi, noe som signaliserer dårlig investering.",
            info_yearly_mileage: "Høyere kilometerstand øker slitasje. Lav kilometerstand kan betydelig forlenge bilens levetid.",
            info_estimated_repairs: "Løpende kostnad for å holde bilen i drift. Høye årlige kostnader reduserer attraktiviteten ved å beholde bilen.",
            info_planned_repairs: "Kjente kommende reparasjoner. Simulerer umiddelbart press på avgjørelsen din.",
            info_ownership_years: "Hvor lenge har du eid denne bilen? Dette påvirker psykologisk eierskapsutmattelse og bias hos den opprinnelige kjøperen.",
            info_rust: "Kritisk langsiktig risiko. Strukturell rust reduserer sikkerheten. Alvorlig rust gjør salg til et bedre alternativ.",
            info_crashes: "Strukturelle ulykker påvirker sikkerhet og pålitelighet. De reduserer også videresalgsverdien betydelig.",
            info_repaint: "Signaliserer tidligere skader eller kosmetiske reparasjoner. Lite innvirkning med mindre dypere problemer var skjult.",
            info_unresolved: "Skjulte fremtidige kostnader. Kjente feil i elektronikk, motor eller vedlikehold som trenger oppmerksomhet.",
            info_fit: "Passer bilen til dine behov (plass, komfort)? En dårlig passform betyr at du er mer sannsynlig å erstatte den.",
            info_joy: "Emosjonell verdi betyr noe. Ingen glede betyr at du mentalt er klar for en ny bil.",
            info_worry: "Oppfattet pålitelighetsstress. Høy bekymring er et sterkt signal om å erstatte bilen.",
        },
        explanations: {
            repairFreq: "Bilen din hadde {visits} servicebesøk de siste 12 månedene. Hyppige besøk indikerer lavere pålitelighet og høyere bry.",
            repairVsValue: "I løpet av de siste 12 månedene kostet reparasjonene dine €{cost}, mens bilens estimerte verdi er €{value}. Det er {ratio}% av bilens totale verdi.",
            stableRepairsDetailYearly: "I fjor brukte du €{cost1} på reparasjoner, men året før €{cost2}. Endring på {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "De siste 6 månedene brukte du €{cost1}, de foregående 6 månedene €{cost2}. Endring på {percent}% ({trend}).",
            mileage: "Ved {mileage} km går bilen inn i en høyere risikosone for store delfeil (transmisjon, motor komponenter).",
            planned: "Du har €{cost} i planlagte reparasjoner, som umiddelbart reduserer den økonomiske sikkerheten ved å beholde bilen.",
            lowDep: "Biler verdsatt rundt €{value} mister svært lite verdi per år, noe som motvirker høyere reparasjonskostnader.",
            depRisk: "Bilen din er {age} år gammel og har stort sett fullført sitt avskrivningssyklus, noe som betyr at du ikke taper penger på verdifallet.",
            stable: "Du brukte €{costThisYear} i år mot €{costLastYear} i fjor, som er en {percent}% reduksjon. Forutsigbare kostnader er matematisk gunstige.",
            costKm: "Du kjørte {km} km i fjor. Driftskostnadene var €{costKm} per kilometer, noe som viser utmerket økonomisk effektivitet.",
            fixedCosts: "Du betalte €{costs} i faste årlige kostnader (forsikring/skatt). Dette lave fotavtrykket gir ekstra trygghet.",
            usage: "Du kjører rundt {km} km per år basert på loggene dine.",
            practical_fit: "Du vurderte den praktiske tilpasningen til {score}/5, og justerte den matematiske poengsummen med {impact} poeng.",
            emotional_satisfaction: "Du vurderte din emosjonelle tilfredshet til {score}/5, og justerte poengsummen med {impact} poeng.",
            reliability_anxiety: "Din pålitelighet tillit er {score}/5, som påvirker poengsummen med {impact} poeng.",
            rust: "Alvorlig strukturell eller underbil rust betyr vanligvis sikkerhetsfarer eller avskrivningsscenarier.",
            accident: "Tidligere skade, avhengig av alvorlighetsgrad, reduserer iboende bilens videresalgsverdi og sikkerhet.",
            structural: "Strukturelle problemer gjør bilen økonomisk farlig.",
            ai_lifespan: "Ved {current} km har bilen fullført {ratio}% av sin AI-estimerte levetid ({expect} km).",
            ai_repairs: "AI-dataene indikerer at {count} typiske modellspesifikke store reparasjoner pleier å skje ved denne kjørelengden.",
            lifecycle_stage: "Hva betyr levetid? {total} km – dette er det AI-predikerte punktet når store strukturelle reparasjoner (motor, girkasse, osv.) vanligvis begynner for denne modellen. Det er ikke slutten på bilens liv – bilen kan fortsatt kjøre, men med betydelig høyere vedlikeholdskostnader. En typisk bils fulle fysiske levetid er 500k–1M km, men den blir økonomisk uholdbar mye tidligere.",
        },
        ratios: {
            healthy: "Sunn",
            monitor: "Overvåk",
            highRisk: "Høy risiko",
            stable: "Stabil",
            warning: "Advarsel",
            financialStress: "Økonomisk stress",
        },
        proFeatureTitle: "Pro-funksjon: Reparasjonsmodus",
        proFeatureDesc: "Lås opp beslutningsmotoren for å få en profesjonell økonomisk analyse av bilreparasjonene dine. Gratisbrukere ser en demonstrasjon med eksempeldata.",
        viewDemo: "Se Live Demo",
        upgradeToUnlock: "Oppgrader til PRO for å analysere bilen din",
    },
    carTasks: {
        title: "Biloppgaver",
        placeholderTitle: "Vedlikeholdssporing",
        placeholderDesc: "Vedlikeholdsplan for din bilmodell.",
        demoTitle: "Bilvedlikeholdsoppgaver",
        demoSubtitle: "Smart sporing for ditt kjøretøy",
        feature1Title: "Automatisert Oppgavegenerering",
        feature1Desc: "Genererer automatisk oppgaver som oljeskift, filterbytter og timingbelte-sjekker basert på din bilmodell.",
        feature2Title: "Kostnadsintegrasjon",
        feature2Desc: "Analyserer din servicehistorikk for å forstå hva som allerede er gjort og når.",
        feature3Title: "Smarte Påminnelser",
        feature3Desc: "Få varsler basert på både tid og kjørelengde. Sporingen tilbakestilles automatisk når du markerer en oppgave som fullført.",
        getStarted: "Kom i gang",
        fakeDoorPopupTitle: "Tilbakemelding Velkommen",
        fakeDoorPopupMessage: "Vi utvikler for øyeblikket bilvedlikeholdsoppgaver. Denne funksjonen vil la deg spore serviceintervaller automatisk. Hvilke spesifikke oppgaver eller funksjoner ønsker du å se mest?",
        fakeDoorPopupPlaceholder: "Dine tanker...",
        noTasksYet: "Ingen oppgaver ennå",
        deleteAllTitle: "Tømme oppgavelisten?",
        deleteAllMessage: "Er du sikker på at du vil slette alle {count} oppgaver for denne bilen? Denne handlingen kan ikke angres.",
        deleteAllSuccess: "Alle oppgaver har blitt slettet.",
        sortPriority: "Prioritet",
        sortType: "Type",
        sortDate: "Nyeste",
        status: {
            overdue: "FORFALLEN",
            pending: "VENTER",
            noData: "INGEN DATA",
            upcoming: "Kommende",
            nextIn: "Neste om {dist} {unit}",
            overdueBy: "{dist} {unit} forfalt",
            afterDays: "Om {days} dager",
            overdueDays: "{days} dager forfalt",
        },
        form: {
            newTitle: "Ny Oppgave",
            actionType: "Inspiser eller Bytt?",
            intervalMonths: "Intervall (Måneder)",
            intervalDistance: "Intervall (Avstand)",
            diffFirstInterval: "Første intervall avviker fra basisintervall",
            firstInterval: "Første Intervall",
            historyToggle: "Har denne oppgaven noen gang blitt utført for denne bilen?",
            historyToggleDesc: "Hvis NEI, antar vi at det aldri har blitt gjort siden produksjon.",
            lastPerformedOptional: "Når ble det sist utført? (Valgfritt)",
            deleteTitle: "Slett Oppgave",
            deleteConfirm: "Er du sikker på at du vil slette denne oppgaven?",
            saveError: "Kunne ikke lagre oppgaven",
            historyConfirmed: "Historikk Bekreftet",
            reminders: "Påminnelser",
            notifyMileage: "Gi meg beskjed når estimert kjørestand er nådd",
            notifyDate: "Gi meg beskjed når datoen er nådd",
            nextMileageReminder: "Estimert dato",
            nextDateReminder: "Forfallsdato",
            estimatedDate: "Estimert dato",
            missingLastMileage: "Mangler siste kjørte kilometer",
            missingLastDate: "Mangler siste utførte dato",
            missingStartDate: "Kunne ikke bestemme startdato",
            additionalOptions: "Tilleggsalternativer",
            reminderInfoMissing: "Informasjonsstatus: påminnelser er deaktivert inntil siste utførte data er gitt.",
        },
    },
    dashboard: {
        title: "Dashbord",
        quickActions: "Hurtighandlinger",
        addExpense: "Legg til utgift",
        editCar: "Rediger bil",
        recentExpenses: "Utgifter",
        seeAll: "Se alle",
        recentGallery: "Filer",
        thisMonth: "Denne måneden",
        totalSpent: "Totalt brukt",
        avgPerMonth: "Gjennomsnitt/måned",
        recentNotes: "Notater",
        recentParts: "Deler",
        noRecentExpenses: "Ingen nylige utgifter",
        noRecentGallery: "Ingen nylige bilder",
        noRecentNotes: "Ingen nylige notater",
        noRecentParts: "Ingen nylige deler",
        createNote: "Opprett ny",
        createPart: "Opprett ny",
        createExpense: "Opprett ny",
        noFiles: "Ingen filer lagt til ennå",
        needSomethingMore: "Trenger du noe mer?",
        letUsKnow: "gi oss beskjed!",
    },
    expenseTypes: {
        editTitle: "Rediger utgiftstype",
        newTitle: "Ny utgiftstype",
        categoryName: "Kategorinavn",
        placeholderName: "f.eks. Service",
        signatureColor: "Signaturfarge",
        icon: "Kategoriikon",
        deleteConfirm: "Er du sikker på at du vil slette type '{name}'?",
    },
    spareParts: {
        title: "Reservedeler",
        connectedWithRecords: "Koblet med opptegnelser",
        toBuy: "Å kjøpe",
        usedInExpenses: "Brukt i utgifter",
        noPartsToBuy: "Ingen deler lagt til handlelisten",
        noPartsUsed: "Ingen deler knyttet til utgifter ennå",
        quantity: "Ant.",
        partCode: "Delenummer",
        price: "Pris",
        link: "Lenke",
        comment: "Kommentar",
        addPart: "Legg til reservedel",
        editPart: "Rediger reservedel",
        openPart: "Åpne deloppføring",
        nameLabel: "Navn",
        manufacturerLabel: "Produsent",
        priceLabel: "Pris ({currency})",
        imagesLabel: "Filer",
        linkedHistory: "Knyttede historikk",
        partManagedNote: "Denne delen administreres gjennom en utgift",
        cannotDeleteNote: "Siden denne delen er knyttet til en utgift, kan den ikke slettes separat. Slett eller rediger utgiften for å administrere denne delens livssyklus.",
        partNamePlaceholder: "Delenavn...",
        manufacturerPlaceholder: "Bosch, Brembo, osv.",
        additionalInfoPlaceholder: "Tilleggsinformasjon...",
        namePlaceholder: "f.eks. Bremseskiver",
        codePlaceholder: "f.eks. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Lagre del",
        deletePart: "Slett reservedel",
        deleteConfirm: "Er du sikker på at du vil slette denne reservedelen?",
        sparePartsLabel: "Reservedeler",
        partNumber: "Del #{number}",
        imagesLimitLabel: "Filer (opptil 5)",
        optional: "(valgfritt)",
        selectPart: "Velg reservedel",
        createNew: "Opprett ny reservedel",
        searchPlaceholder: "Søk etter navn eller kode...",
        noResults: "Ingen deler funnet",
        noPartsYet: "Ingen deler ennå. Opprett din første!",
        selectorDescription: "Finn og velg en eksisterende reservedel, eller opprett en ny",
        alreadyAdded: "Denne delen er allerede lagt til",
        statistics: {
            avgPrice: "Gjennomsnitt",
            lastPrice: "Siste",
            usedTimes: "Brukt {count} ganger",
            totalPurchased: "Totalt: {quantity}x",
        },
        usage: {
            title: "Dette kjøpet",
            quantity: "Antall",
            pricePerUnit: "Pris per enhet",
            comment: "Kommentar",
            commentPlaceholder: "f.eks., Kjøpt hos AutoZone",
            total: "Totalt",
            transactionData: "Denne transaksjonen",
        },
        masterData: "Hoveddelinfo",
        masterRecord: {
            title: "Del detaljer (delt)",
            editMaster: "Rediger masteroppføring",
            warning: "Endringer i masteroppføringen påvirker alle bruksområder",
        },
    },
    reminders: {
        title: "Påminnelser",
        reminder: "Påminnelse",
        noteReminder: "Notatpåminnelse",
        partReminder: "Dels påminnelse",
        today: "I dag",
        tomorrow: "I morgen",
        yesterday: "I går",
        inXDays: "om {x} dager",
        xDaysAgo: "for {x} dager siden",
        inXMonths: "om {x} måneder",
        xMonthsAgo: "for {x} måneder siden",
        active: "Aktiv",
        activeDesc: "Hvis nødvendig, kan du slå av denne påminnelsen uten å slette den",
        disabled: "Deaktivert",
        yearly: "Årlig",
        markSeen: "Bekreft",
        addReminder: "Ny påminnelse",
        editReminder: "Rediger påminnelse",
        extraReminders: "Ekstra påminnelser",
        extraRemindersDesc: "Send 3 ekstra påminnelser på følgende dager (4 totalt) hvis ikke stoppet.",
        remindDate: "Dato",
        remindTime: "Tid",
        repeatYearly: "Gjenta årlig",
        repeatYearlyDesc: "Denne påminnelsen vil automatisk skje hvert år på samme dato/måned/dag/tid inntil den deaktiveres",
        standalone: "Uavhengige påminnelser",
        embedded: "Koblede påminnelser",
        noReminders: "Ingen aktive påminnelser",
        deleteReminder: "Slett påminnelse",
        nameLabel: "Navn",
        descriptionLabel: "Beskrivelse",
        namePlaceholder: "Påminnelsesnavn",
        descriptionPlaceholder: "Kort beskrivelse eller notat",
        simulateReminder: "Simuler påminnelsesøyeblikk",
        simulateSuccess: "Simulerings-e-post sendt",
        timezone: "Tidssone",
        nextReminder: "Neste påminnelse",
        futureTimeError: "Påminnelsestid må være i fremtiden",
    },
    notes: {
        title: "Notater",
        emptyNote: "Tomt notat",
        noNotes: "Ingen notater ennå",
        addNote: "Legg til notat",
        editNote: "Rediger notat",
        viewNote: "Vis notat",
        openNote: "Åpne notatoppføring",
        titleLabel: "Tittel",
        contentLabel: "Innhold",
        noteTitlePlaceholder: "Notat tittel...",
        noteContentPlaceholder: "Skriv notatet ditt her...",
        saveNote: "Lagre notat",
        deleteNote: "Slett notat",
        publicNote: "Gjør notatet offentlig",
        publicNoteDesc: "Andre kan se dette notatet via delt lenke",
        deleteConfirm: "Er du sikker på at du vil slette dette notatet?",
        enterTitleAlert: "Vennligst skriv inn en tittel",
        saveFailed: "Kunne ikke lagre notat",
        thisNote: "Dette notatet",
        deleteFailed: "Kunne ikke slette notat",
        pinToTop: "Fest til toppen",
    },
    locations: {
        title: "Steder",
        singleTitle: "Sted",
        newLocation: "Nytt sted",
        emptyLocation: "Tomt sted",
        noLocations: "For statistikk - du kan legge til stedet der denne bilutgiften oppstod",
        addLocation: "Legg til sted",
        editLocation: "Rediger sted",
        viewLocation: "Vis sted",
        openLocation: "Åpne sted",
        createNew: "Opprett nytt sted",
        selectLocation: "Velg sted",
        searchLocations: "Søk etter steder...",
        nameLabel: "Navn",
        addressLabel: "Adresse eller koordinater",
        descriptionLabel: "Kommentar/Beskrivelse",
        namePlaceholder: "f.eks., Sentrumstjeneste",
        mapLabel: "Sted",
        searchPlaceholder: "Søk adresse...",
        addressPlaceholder: "Skriv inn adresse og velg...",
        descriptionPlaceholder: "Tilleggsinformasjon...",
        fillAddress: "Fyll adresse fra kart",
        saveLocation: "Lagre sted",
        deleteLocation: "Slett sted",
        deleteConfirm: "Er du sikker på at du vil slette dette stedet?",
        enterNameAlert: "Vennligst skriv inn et navn",
        saveFailed: "Kunne ikke lagre sted",
        thisLocation: "Dette stedet",
        deleteFailed: "Kunne ikke slette sted",
        myLocations: "Mine steder",
        usedInEntries: "Brukt i oppføringer",
        noEntries: "Stedet er ikke brukt",
        noEntriesThisCar: "Dette stedet har ikke vært brukt for denne bilen",
        removeLocation: "Fjern sted",
        noResults: "Ingen resultater funnet",
    },
    gallery: {
        title: "Filer",
        noImages: "Ingen bilder lagt til",
        addImagesNote: "Legg til bilder av bil eller utgifter",
        totalImages: "Totalt {count} bilder",
        imageAlt: "Bilde {number}",
        commentPlaceholder: "Filkommentar",
        isReceipt: "Denne filen er en kvittering",
        deleteImageTitle: "Slett fil",
        deleteImageConfirm: "Er du sikker på at du vil slette denne filen permanent?",
    },
    search: {
        placeholder: "Søk etter utgifter, deler, notater...",
        typeToSearch: "Skriv for å begynne å søke",
        noResults: "Ingen resultater funnet for '{query}'",
        carImage: "Bilbilde",
        expenseImage: "Utgiftsbilde",
        noteImage: "Notatbilde",
        galleryImage: "Galleri bilde",
        untitledExpense: "Uten tittel utgift",
    },
    landing: {
        nav: {
            features: "Funksjoner",
            howItWorks: "Slik fungerer det",
            pricing: "Priser",
            login: "Logg inn",
            getStarted: "Kom i gang",
            garage: "Garasje",
        },
        hero: {
            title: "Vet Nøyaktig Hva Bilen Din",
            subtitle: "Egentlig Koster",
            description: "Følg med på utgifter, loggfør reparasjoner, og se hvor pengene dine egentlig går.",
            subheadline: "Det profesjonelle datadrevne dashbordet for nøye bileiere.",
            startTracking: "Kom i gang",
            viewDemo: "Demo Bil ->",
            trustSignal: "Bli med 1,200+ nøye eiere som allerede har kartlagt over 5 millioner kilometer med virkelige bilkostnader.",
            ctaNote: "Ingen kredittkort. Ingen påtrengende salg. Bare klarhet.",
            benefits: {
                repairVsSell: {
                    title: `Reparere vs. Selge`,
                    description: `Se "Reparere vs. Selge" terskelen — Slutt å lure på om du kaster penger inn i en pengesluker. Vit det eksakte øyeblikket en reparasjon ikke lenger er en smart investering.`
                },
                costPerKm: {
                    title: `Kostnad-per-KM`,
                    description: `Følg din reelle kostnad-per-kilometer — Gå utover dashbordet. Se det fulle økonomiske bildet av dine kjørevaner som andre apper utelater.`
                },
                automation: {
                    title: `Automatisering`,
                    description: `Automatiser din registrering — Bare videresend fakturaene dine eller send enkelt notatene dine på e-post. Vår AI organiserer bilens tekniske historie for deg.`
                }
            },
        },
        features: {
            title: "Alt du trenger for å administrere bilen din",
            subtitle: "Slutt å bruke regneark og rotete mapper. Mine bilkostnader gir profesjonelle verktøy for flåteadministrasjon til ditt personlige garasje.",
            expenseTracking: {
                title: "Utgiftssporing",
                description: "Loggfør drivstoff, service, forsikring og reparasjoner. Kategoriser kostnader og visualiser forbrukstrender over tid.",
            },
            spareParts: {
                title: "Reservedelsadministrator",
                description: "Hold en detaljert oversikt over reservedeler, delenummer og kompatibilitetsnotater for alle reparasjonene dine.",
            },
            serviceHistory: {
                title: "Servicehistorikk & Notater",
                description: "Oppretthold en digital servicebok. Legg til detaljerte notater om vedlikehold, modifikasjoner eller fremtidige planer.",
            },
            documentStorage: {
                title: "Dokumentlagring",
                description: "Last opp kvitteringer, fakturaer og bilder av bilen din. Hold all dokumentasjon trygg og tilgjengelig.",
            },
            emailForwarding: {
                title: "E-postviderekobling",
                description: "Viderekoble fakturaer direkte til din unike innboks. Vi henter dataene og legger dem til dashbordet ditt automatisk.",
            },
            multiCar: {
                title: "Flere biler garasje",
                description: "Administrer én bil eller en hel flåte. Bytt mellom kjøretøy umiddelbart og se aggregerte statistikker.",
            },
            repeatingExpenses: {
                title: "Gjentakende utgifter",
                description: "Automatiser sporing av faste månedlige kostnader som forsikring, parkering eller leasing.",
            },
            smartReminders: {
                title: "Smarte påminnelser",
                description: "Sett tilpassede varsler for reservedeler og service-notater for aldri å gå glipp av en vedlikeholdsoppgave.",
            },
        },
        howItWorks: {
            title: "Enkel, kraftig arbeidsflyt",
            step1: {
                title: "Legg til kjøretøyet ditt",
                description: "Skriv inn bilens detaljer for å opprette ditt digitale garasje.",
            },
            step2: {
                title: "Loggfør utgifter & filer",
                description: "Ta et bilde av en kvittering eller videresend en e-post. Vi tar oss av resten.",
            },
            step3: {
                title: "Få innsikt",
                description: "Se kostnaden per kilometer, månedlige utgifter og vedlikeholds tidslinje.",
            },
        },
        useCases: {
            title: "Perfekt for",
            enthusiasts: {
                title: "Bilentusiaster",
                description: "Spor hver modifikasjon, delenummer og vedlikeholdsintervall for prosjektbilen din.",
            },
            dailyDrivers: {
                title: "Daglige sjåfører",
                description: "Vet nøyaktig hvor mye pendlingen koster og aldri gå glipp av en service dato.",
            },
            flippers: {
                title: "Den Smarte Flipperen",
                description: "Bygg et verifiserbart volum av data som beviser bilens sanne verdi for kjøpere.",
            },
            fleets: {
                title: "Små flåter",
                description: "Administrer flere firmabiler på ett sted uten unødvendig programvare.",
            },
        },
        foundersNote: {
            title: "Grunnleggers Notat",
            content: "Jeg bygger MyCarCosts for å være det ultimate verktøyet for folk som faktisk bryr seg om bilene sine. Er det en funksjon som mangler i arbeidsflyten din? Kontakt meg direkte. Hvis det gir mening for fellesskapet, bygger vi det sammen.",
        },
        pricing: {
            freeLimitedTime: "Gratis i en begrenset periode",
            title: "Enkle, transparente priser",
            subtitle: "Start gratis, oppgrader etter hvert som du vokser.",
            perMonth: "måned",
            monthly: "Månedlig",
            yearly: "Årlig",
            save25: "Spar 25%",
            billedAnnually: "Faktureres årlig ({amount})",
            free: {
                title: "Gratis",
                cta: "Kom i gang",
            },
            pro: {
                title: "Pro",
                cta: "Oppgrader til Pro",
                recommended: "Anbefalt",
                earlyAdopter: "Priser for tidlige brukere",
                priceLock: "Lås inn denne prisen nå. Prisen kan øke i fremtiden.",
            },
            custom: {
                title: "Custom",
                cta: "Kontakt oss",
            },
            features: {
                oneCar: "1 bil",
                unlimitedExpenses: "Ubegrensede utgifter",
                unlimitedSpareParts: "Ubegrensede reservedeler",
                unlimitedNotes: "Ubegrensede notater",
                repeatedExpenses: "Gjentatte utgifter",
                emailReminders: "Notater og reservedeler e-postpåminnelser",
                basicStatistics: "Grunnleggende statistikk",
                fullStatistics: "Full statistikk",
                storage50mb: "50 Mb fil-lagring",
                unlimitedArchivedCars: "Ubegrensede arkiverte biler",
                dataExport: "Dataeksport",
                allInFreePlus: "alt i gratis pluss:",
                threeCars: "Opp til 3 biler",
                storage2gb: "2 Gb fil-lagring",
                emailParsing: "E-post parsing",
                carAdmins: "Biladministratorer",
                moreCars: "Flere biler",
                moreFileStorage: "Mer fil-lagring",
                customRequirements: "Tilpassede krav",
            },
            upgradePopup: {
                title: "Kommer snart!",
                message: "Pro- og tilpassede versjoner er ikke lansert ennå, men de vil komme snart. For å hjelpe oss med å lansere raskere - vennligst skriv ned hvilken spesifikk funksjon du forventer fra pro / tilpasset versjon, eller noe annet du ønsker at vi skal forbedre for å gjøre denne plattformen enda bedre for deg!",
                placeholder: "Skriv tilbakemeldingen din her...",
                submit: "Send",
                cancel: "Avbryt",
                thanksTitle: "Takk!",
                thanksMessage: "Vi har mottatt tilbakemeldingen din og vil jobbe for å gjøre MyCarCosts enda bedre!",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "Flytter fra Excel eller en annen app?",
            subtitle: "Vi tilbyr en profesjonell datamigreringstjeneste for å få deg opp og gå umiddelbart.",
            pricingModel: "Prismodell",
            small: {
                title: "Lite datasett",
                description: "< 500 rader",
                price: "kr 19–29",
            },
            medium: {
                title: "Moderat datasett",
                description: "500–5 000 rader",
                price: "kr 49",
            },
            large: {
                title: "Stort / Rotete",
                description: "Legacy-systemer eller komplekse filer",
                price: "Tilpasset tilbud",
            },
            process: {
                title: "Slik fungerer det",
                step1: "Du sender inn filen din",
                step2: "Vi vurderer dataene",
                step3: "Engangsbetaling",
                step4: "Vi håndterer importen",
            },
            cta: "Be om migrering",
        },
        repairAnalysisSection: {
            title: "Reparere eller selge? La dataene avgjøre.",
            subtitle: "Profesjonell finansiell analyse for ditt kjøretøy. Slutt å gjette og begynn å vite om reparasjonene virkelig er verdt det.",
            features: {
                personalized: {
                    title: "Personlig Analyse",
                    description: "For bilene du har registrert, bruker vi faktiske historiske utgifter og parametere, og legger til planlagte kostnader for å generere en vurdering.",
                },
                public: {
                    title: "Offentlig Simulator",
                    description: "Vurderer du et potensielt kjøp? Bruk vårt offentlige verktøy på /repair for å generere en detaljert analyse ved å angi bare noen få nøkkeldetaljer.",
                },
                whatIf: {
                    title: "Hva-hvis-simulator",
                    description: "Skriv inn en planlagt reparasjonskostnad og se umiddelbart hvordan det påvirker bilens økonomiske poengsum.",
                },
            },
            cta: "Se eksempelanalyse",
        },
        faq: {
            title: "Ofte stilte spørsmål",
            subtitle: "Alt du trenger å vite om Mine Bilkostnader",
            questions: {
                mobileApps: {
                    question: "Vil det komme iOS- og Android-apper?",
                    answer: "Ja! Mobilapper for både iOS og Android kommer snart. Vi jobber hardt for å gi deg den beste mobilopplevelsen.",
                },
                dataPrivacy: {
                    question: "Er dataene mine private og sikre?",
                    answer: "Absolutt. Dine data er kryptert og lagret sikkert. Bare du kan få tilgang til bilinformasjonen din med mindre du eksplisitt velger å gjøre den offentlig.",
                },
                freePlan: {
                    question: "Er den gratis planen virkelig gratis for alltid?",
                    answer: "Ja! Den gratis planen vil alltid være tilgjengelig med én bil og alle essensielle funksjoner. Du kan oppgradere til Pro når som helst for opptil 3 biler og avanserte funksjoner.",
                },
                dataExport: {
                    question: "Kan jeg eksportere dataene mine?",
                    answer: "Ja, du kan eksportere alle dataene dine når som helst i CSV- eller PDF-format. Dine data er dine, og du er aldri låst inne.",
                },
                emailImport: {
                    question: "Hvordan fungerer e-postimport?",
                    answer: "Hver bil får en unik e-postadresse. Bare videresend fakturaene dine, så henter vi dataene automatisk.",
                },
                multipleUsers: {
                    question: "Kan flere personer få tilgang til den samme bilen?",
                    answer: "For øyeblikket tilhører hver bil én konto. Du kan imidlertid gjøre en bil offentlig synlig for å dele skrivebeskyttet tilgang med andre.",
                },
            },
        },
        cta: {
            title: "Slutt å gjette. Begynn å vite.",
            subtitle: "Forvandle bilens historikk til klare økonomiske beslutninger. Bli med tusenvis av smarte eiere som vet nøyaktig når de skal investere eller selge.",
            button: "Start nå",
            note: "Ingen kredittkort. Ingen påtrengende salg. Bare klarhet.",
        },
        footer: {
            product: "Produkt",
            legal: "Juridisk",
            changelog: "Endringslogg",
            privacy: "Personvernerklæring",
            contact: "Kontakt",
            contactEmail: "info@mycarcosts.com",
            questions: "Har du spørsmål? Kontakt oss på:",
        },
        privacy: {
            title: "Personvernerklæring",
            lastUpdated: "Sist oppdatert: 25. mars 2026",
            introduction: "Hos Mine Bilkostnader tar vi personvernet ditt på alvor. Denne policyen forklarer hvordan vi håndterer dataene dine.",
            dataCollection: {
                title: "Datainnsamling",
                description: "Vi samler kun inn det absolutt minimum av informasjon som kreves for å tilby tjenesten vår.",
                email: "Kontoidentitet: Vi bruker e-postadressen din som din unike identifikator og for autentisering (f.eks. magiske lenker eller Google-pålogging).",
                documents: "Dokumentlagring: Filer du laster opp lagres sikkert i kryptert skylagring.",
            },
            carData: {
                title: "Din Datakontroll",
                description: "Informasjonen du oppgir (utgifter, kjørelengde, deler) lagres for ditt personlige bruk og analyse.",
                noValidation: "Vi validerer ikke bildataene du oppgir; det er ditt ansvar å sikre nøyaktighet.",
                privateByDefault: "Som standard er dataene dine private. Tekniske identifikatorer for filer er ikke-sekvensielle og indekseres ikke av søkemotorer.",
                rightToForgotten: "Retten til å bli glemt: Du kan slette kontoen din når som helst, noe som umiddelbart og permanent fjerner alle dine poster og filer.",
            },
            thirdParty: {
                title: "Tredjeparts tjenester",
                description: "Vi selger ikke dine personlige data. Når du bruker Google-innlogging, får vi bare tilgang til e-postadressen din for identifikasjonsformål.",
            },
            emailIngestion: {
                title: "E-postinnsamling",
                description: "E-poster sendt til vår innsamlingstjeneste lagres for å gi en behandlingshistorikk. Du kan manuelt slette individuelle e-poster eller hele historikken når som helst.",
            },
        },
        emails: {
            deleteAll: "Slett alt",
            deleteAllConfirm: "Er du sikker på at du vil slette all e-posthistorikk for denne bilen? Denne handlingen kan ikke angres.",
            deleteConfirm: "Er du sikker på at du vil slette denne e-posten?",
            noEmails: "Ingen e-poster mottatt ennå.",
        },
        terms: {
            title: "Vilkår og betingelser",
            lastUpdated: "Sist oppdatert: 25. mars 2026",
            introduction: "Ved å gå inn på eller bruke Mine Bilkostnader, godtar du å være bundet av disse vilkårene og betingelsene. Hvis du ikke er enig, vennligst ikke bruk tjenesten vår.",
            acceptance: {
                title: "1. Aksept av vilkår",
                description: "Disse vilkårene utgjør en juridisk bindende avtale mellom deg og Mine Bilkostnader angående din bruk av vår applikasjon og tjenester.",
            },
            service: {
                title: "2. Beskrivelse av tjenesten",
                description: "Mine Bilkostnader tilbyr en plattform for sporing av kjøretøyutgifter, vedlikeholdshåndtering og økonomisk analyse. Dette inkluderer AI-drevet parsing av kvitteringer og verktøy for datavisualisering.",
            },
            responsibilities: {
                title: "3. Brukerens ansvar",
                description: "Du er ansvarlig for nøyaktigheten av alle data du legger inn, inkludert kilometerstand, VIN-numre og kostnader. Du må holde påloggingsinformasjonen din (e-post/magisk lenke) sikker og ikke dele dem med uautoriserte parter.",
            },
            plans: {
                title: "4. Tjenesteplaner og grenser",
                description: "Vi tilbyr gratis- og Pro-planer med forskjellige lagrings-, bilantall- og opplastingsgrenser. Vi forbeholder oss retten til å endre disse grensene eller introdusere nye abonnementstrinn når som helst.",
            },
            disclaimer: {
                title: "5. Ansvarsfraskrivelser og nøyaktighet",
                description: "Mine Bilkostnader er et informasjons- og organisasjonsverktøy. Vi tilbyr ikke offisielle sertifiseringer for kjøretøyhelse. AI-parsede data fra kvitteringer bør alltid verifiseres av brukeren for nøyaktighet.",
            },
            liability: {
                title: "6. Ansvarsbegrensning",
                description: "Mine Bilkostnader leveres 'som den er'. Vi er ikke ansvarlige for mekaniske problemer, økonomiske tap eller datanøyaktigheter som gevolg av bruken av vår applikasjon.",
            },
            termination: {
                title: "7. Oppsigelse",
                description: "Du kan slutte å bruke tjenesten og slette dataene dine når som helst. Vi forbeholder oss retten til å suspendere eller avslutte kontoer som bryter disse vilkårene eller utviser støtende oppførsel.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

